export const enLang = {
    'LANG': 'en',
    'ADD': 'Add',
    'FILTER': 'Filter',
    'FILTERS': 'Filters',
    'DIMENSIONS': 'Dimensions',
    'HOME': 'Dashboard',
    'USERS': 'Users',
    'USER': 'User',
    'PLOT': 'Plot',
    'PLOTS': 'Plots',
    'COMMERCES': 'Commerces',
    'COMMERCE': 'Commerce',
    'DOCUMENT': 'Document',
    'DOCUMENTS': 'Documents',
    'PURCHASER': 'Purchaser',
    'FEEDBACK': 'Feedback',
    'FEEDBACKS': 'Feedbacks',
    'NOTIFICATION': 'Emails',
    'AUDIT': 'Audit',
    'CONTENT': 'Content',
    'SEARCH': 'Search',
    'NAME': 'Name',
    'EMAIL': 'Email',
    'ROLES': 'Roles',
    'DATE': 'Date',
    'HOUR': 'Hour',
    'STATE': 'State',
    'SELECT': 'Select',
    'ORGANIZATION': 'Organization',
    'JOB_TITLE': 'Job Title',
    'SEX': 'Sex',
    'LAST_NAME': 'Last name',
    'PHONE': 'Phone',
    'RUC': 'RUC',
    'PASSWORD': 'Password',
    'CONFIRM_PASSWORD': 'Confirm Password',
    'USER_ADMIN': 'User Administrator',
    'CONTENT_ADMIN': 'Content Administrator',
    'COMMERCE_ADMIN': 'Commerce Administrator',
    'DOCUMENT_ADMIN': 'Documents Administrator',
    'AUDIT_ADMIN': 'Audit Administrator',
    'EMAIL_ADMIN': 'Email Administrator',
    'FEEDBACK_ADMIN': 'Feedback Administrator',
    'SUPER_ADMIN': 'Super Administrator',
    'USER_EDIT': 'Edit user',
    'USER_CREATE': 'New User',
    'SIGN_IN': 'Sign In',
    'MALE': 'Male',
    'FEMALE': 'Female',
    'USER_CREATED_TITLE': 'Create User',
    'USER_CREATED_SUCCESS_MESSAGE': 'The user was created successfully',
    'USER_UPDATED_TITLE': 'Edit User',
    'USER_UPDATED_SUCCESS_MESSAGE': 'The user was updated successfully',
    'PASSWORD_DO_NOT_MATCH': 'The password and the confirm password do not match',
    'MISSING_REQUIRED_ARGUMENTS_USER_EDITOR': 'Are missing the following required fields',
    'USER_DELETE_CONFIRM_TITLE': 'Delete User',
    'USER_DELETE_CONFIRM_BODY': 'Are you sure you want to delete the user <b>%s</b> with the email <b>%s</b>',
    'CLOSE': 'Close',
    'CANCEL': 'Cancel',
    'SAVE': 'Save',
    'USER_ADMIN_MODULE_NAME': 'User Administration Module',
    'COMMERCE_ADMIN_MODULE_NAME': 'Commerce Administration Module',
    'CONTENT_ADMIN_MODULE_NAME': 'Content Administration Module',
    'EMAIL_ADMIN_MODULE_NAME': 'Email Administration Module',
    'AUDIT_ADMIN_MODULE_NAME': 'Audit Module',
    'PLOT_ADMIN_MODULE_NAME': 'Plots Module',
    'PENDING': 'Pending',
    'VIEWED': 'Viewed',
    'ACKNOWLEDGE': 'Acknowledge',
    'REJECTED': 'Rejected',
    'ADDRESS': 'Address',
    'LEGAL_REPRESENTATIVE': 'Legal Representative',
    'NATIONALITY': 'Nationality',
    'COMMERCE_REGISTER_TYPE': 'Registration Type',
    'COMMERCE_RESOLUTION': 'Resolution',
    'IS_IN_ZLC': 'Is on ZLC',
    'COMMERCE_OPERATIONS_KEY': 'Operations Key',
    'ACTIVITY_DESCRIPTION': 'Activity Description',
    'PRODUCTS_DESCRIPTION': 'Products Description',
    'IMPORT_COUNTRIES': 'Import countries',
    'EMPLOYEES': 'Employees',
    'OBSERVATIONS': 'Observations',
    'STATUS': 'Status',
    'COMMERCE_HISTORY': 'History',
    'COMMERCE_DOCUMENTS': 'Documents',
    'COMMERCE_REJECTED_JUSTIFICATION': 'Justification',
    'NOTICE_OPERATIONS': 'Notice of operations',
    'PEACE_SAVE': 'Peace and save',
    'LEGAL_REPRESENTATIVE_ID': 'Legal Representative identification',
    'PUBLIC_RECORD_CERTIFICATE': 'Certificate of public record',
    'AFFIDAVIT_LEGAL_REPRESENTATIVE': 'Legal representative affidavit',
    'HIRING_COMMITMENT_PROPOSAL': 'Hiring commitment proposal',
    'COMMERCE_CREATED_BY': 'Executed By',
    'TITLE': 'Title',
    'TYPE': 'Type',
    'ACTIVE': 'Active',
    'INACTIVE': 'Inactive',
    'DESCRIPTION': 'Description',
    'START_DATE': 'Start date',
    'END_DATE': 'End date',
    'EXPIRATION_DATE': 'Expiration date',
    'DOCUMENT_FILE': 'File',
    'SPANISH': 'Spanish',
    'ENGLISH': 'English',
    'DOCUMENTS_NEW': 'New document',
    'DOCUMENTS_UPDATE': 'Update document',
    'DOCUMENTS_UPDATE_SECTION_TITLE': 'Update existing document',
    'DOCUMENTS_UPDATE_FILENAME': 'Filename',
    'DOCUMENTS_AVAILABILITY_SECTION_TITLE': 'Availability dates',
    'DOCUMENTS_DATE_ERROR': 'The expiration date needs to be after the start date',
    'DOCUMENTS_SELECT_FILE_DEFAULT': 'Choose a file',
    'DOCUMENTS_DELETE_CONFIRM_TITLE': 'Delete Document',
    'DOCUMENTS_DELETE_CONFIRM_BODY': 'Are you sure you want to delete the document <b>%s</b>',
    'DOCUMENTS_SAVED_SUCCESSFULLY_TITLE': 'Document',
    'DOCUMENTS_SAVED_SUCCESSFULLY_BODY': 'The document was saved successfully',
    'LOG_OUT': 'Log out',
    'GENERAL_ERROR': 'An error happened',
    'INVALID_CREDENTIALS_ERROR': 'The user or the password are incorrect, try again',
    'TIMEOUT_ERROR': 'Session time is over please login again',
    'ABSTRACT': 'Abstract',
    'CONTENTS_NEW': 'New content',
    'CONTENT_UPDATE': 'Update content',
    'NEWS': 'News',
    'ANNOUNCEMENT': 'Announcement',
    'EVENT': 'Event',
    'CONTENT_MODAL_TITLE': 'Edit content',
    'CONTENT_IMAGES_TITLE': 'Images',
    'CONTENT_COVER_IMAGE': 'Cover',
    'CONTENT_THUMBNAIL_IMAGE': 'Thumbnail',
    'CONTENT_SELECT_FILE_DEFAULT': 'Select an image',
    'CONTENT_INVALID_IMAGE_TYPE': 'Select an image with a valid extension',
    'CONTENT_SAVED_SUCCESSFULLY_TITLE': 'Content',
    'CONTENT_SAVED_SUCCESSFULLY_BODY': 'The content was saved successfully',
    'CONTENT_DELETE_CONFIRM_TITLE': 'Delete Content',
    'CONTENT_DELETE_CONFIRM_BODY': 'Are you sure you want to delete the content <b>%s</b>',
    'CREATE_CONTENT_SUCCESS_MODAL_ADD_DATA': `%s <b>%s</b> was created successfully, click on <b>Next</b> to open the editor`,
    'NEXT': 'Next',
    'CONTENT_MODAL_LANGUAGE': 'Fill all the languages',
    'CONTENTS': 'Contents',
    'EMAIL_LIST_NEW': 'New Email list',
    'EMAIL_LIST_TYPE_TITLE': 'Type of event',
    'EMAIL_LIST_COUNT_TITLE': 'Emails',
    'EMAIL_LIST_TYPE_NEW_USER': 'New user',
    'EMAIL_LIST_SAVED_SUCCESSFULLY_TITLE': 'Emails',
    'EMAIL_LIST_SAVED_SUCCESSFULLY_BODY': 'The emails were saved successfully',
    'EMAIL_INPUTS_INVALID': 'One or more emails are invalid',
    'FEEDBACK_ADMIN_MODULE_NAME': 'Feedback Administration Module',
    'FEEDBACK_SUBJECT_TITLE': 'Subject',
    'FEEDBACK_TYPE_TITLE': 'Type',
    'FEEDBACK_EMAIL_TITLE': 'Email',
    'FEEDBACK_DATE_TITLE': 'Date',
    'FEEDBACK_TYPE_FEEDBACK': 'Feedback',
    'FEEDBACK_TYPE_COMPLAINT': 'Complaint',
    'FEEDBACK_TYPE_CONGRATULATIONS': 'Congratulations',
    'LOGS': 'Logs',
    'MODULE': 'Module',
    'LOADING': 'Loading',
    'ACTION': 'Action',
    'ERROR_START_DATE_BIGGER_THAN_END_DATE': `Start date can't be after end date`,
    'ERROR_END_DATE_SMALLER_THAN_START_DATE': `End date can't be before end date`,
    'ERROR_ONLY_PDF': `Only pdf files are permitted`,
    'ERROR_RESOLUTION_REQUIRED': `Resolution file is required`,
    'ERROR_RESOLUTION_NOT_AVAILABLE': `Resolution file is not available`,

    // ACTIONS
    'CREATE': 'Create',
    'DOWNLOAD': 'Download',
    'DELETE': 'Delete',
    'UPDATE': 'Update',
    'READ': 'Read',

    // EVENT TYPES
    'EVT_CREATE_USER': 'Create user',
    'EVT_UPDATE_USER': 'Update user',
    'EVT_DELETE_USER': 'Delete user',
    'EVT_CREATE_DOCUMENT': 'Create document',
    'EVT_UPDATE_DOCUMENT': 'Update document',
    'EVT_DELETE_DOCUMENT': 'Delete document',
    'EVT_CREATE_CONTENT': 'Create content',
    'EVT_UPDATE_CONTENT': 'Update content',
    'EVT_UPLOAD_IMAGE_CONTENT': 'Upload image content',
    'EVT_DELETE_CONTENT': 'Delete Content',
    'EVT_CREATE_COMMERCE': 'Create commerce',
    'EVT_CREATE_FEEDBACK': 'Create feedback',
    'EVT_GET_DOCUMENT_BY_ID': 'Get document by id',
    'EVT_DOWNLOAD_COMMERCE_DOCUMENTS_BY_ID': 'Download commerce documents by id',
    'EVT_SET_NOTIFICATION_EMAIL': 'Set notification email',
    'EVT_CREATE_PURCHASER': 'Register purchaser',
    'EVT_GET_REQUEST_COMMERCES': 'Get commerces',
    'EVT_GET_COMMERCE_HISTORY_BY_ID': 'Get commerce history',
    'EVT_GET_FEEDBACK_BY_ID': 'Get feedback by ID',
    'EVT_GET_NOTIFICATION_EMAIL_BY_ID': 'Get notification email by ID',
    'EVT_GET_ALL_NOTIFICATIONS_EMAIL': 'Get notification emails',
    'EVT_GET_USER_BY_ID': 'Get user by ID',
    'EVT_GET_COMMERCE_DOCUMENTS_BY_ID': 'Get commerce documents',
    'EVT_GET_ALL_USERS': 'Get users',
    'EVT_GET_ALL_FEEDBACK': 'Get feedbacks',
    'EVT_GET_COMMERCE_BY_ID': 'Get commerce'
};